<template>
  <div class="member-wrapper">
    <div class='content'>
      <van-cell-group>
        <van-field label="旧密码" v-validate="rules.oldPwd" type="password" v-model.trim="oldPwd" name="oldPwd" :error-message="errors.first('oldPwd')" placeholder="旧密码" required />
        <van-field label="新密码" v-validate="rules.newPwd" type="password" v-model.trim="newPwd" name="newPwd" :error-message="errors.first('newPwd')" placeholder="新密码" required />
        <van-field label="确认密码" v-validate="rules.confirmPwd" type="password" v-model.trim="confirmPwd" name="confirmPwd" :error-message="errors.first('confirmPwd')" placeholder="确认密码" required />
      </van-cell-group>
      <div class='common-btn-wrap'>
        <van-button type="info" :disabled='saveDisabled' size="large" @click="confirmSubmit">确定</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import md5 from 'js-md5';
import { Toast } from 'vant';
export default {
  data () {
    return {
      saveDisabled: false,
      oldPwd: '',
      newPwd: '',
      confirmPwd: '',
      rules: {
        oldPwd: { required: true, formatPassword: true },
        newPwd: { required: true, formatPassword: true },
        confirmPwd: { required: true, formatPassword: true }
      }
    }
  },
  methods: {
    //提交
    confirmSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.confirmPwd != this.newPwd) {
            Toast.fail({
              duration: 1000,
              message: '确认密码和新密码不一致'
            })
            return;
          }
          Toast.loading({
            duration: 0,
            message: '正在保存...',
            overlay: true
          });
          this.saveDisabled = true;
          this.$Request({
            AppID: this.GLOBAL.AppID,
            Method: 'UpdatePassword',
            Account: this.$store.getters.user.Account,//账户:maxlength:100
            Password: md5(this.oldPwd).toUpperCase(),//旧密码:md5加密后的密码 32位大写
            NewPassword: md5(this.newPwd).toUpperCase(),//新密码:md5加密后的密码 32位大写 
          }).then(res => {
            Toast.clear();
            Toast.success({
              duration: 1000,
              message: '修改成功,请重新登陆'
            })
            setTimeout(() => {
              this.saveDisabled = false;
              this.$store.dispatch('FedLogOut').then(() => {
                this.$router.push({ path: '/signIn' });
              })
            }, 1000)
          }, err => {
            setTimeout(() => {
              Toast.clear();
              this.saveDisabled = false;
            }, 3000)
          })
        }

      })

    },
    //自定义字段验证
    validateField () {
      this.$validator.extend('formatPassword', {
        getMessage: field => "请输入6-20位字母数字组成密码",
        validate: (value) => {
          return /^([a-zA-Z0-9]{6,20})$/.test(value)
        }
      });
    }
  },
  created () {
    this.validateField();
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 20px 0;
  .btn-wrap {
    width: 80%;
    text-align: center;
    margin: 100px auto;
  }
}
.van-hairline--top-bottom::after {
  border-width: 0;
}
.common-btn-wrap {
  position: absolute;
  bottom: 200px;
}
</style>


// WEBPACK FOOTER //
// src/views/member/edit-pwd.vue